<div class="form-container">
    <!-- <div class="entry-text" *ngIf="entryText != '' && entryText != undefined "><p>{{ entryText }}</p></div> -->
    <div class="entry-text" *ngIf="entryText != '' && entryText != undefined ">
        <p [innerHTML]="entryText"></p>
    </div>
    <!-- <div *ngIf="!backgroundMedia" class="slideshow">
        <div class="slide active" style="background-image: url('../../../assets/images/1.jpg');"></div>
        <div class="slide" style="background-image: url('../../../assets/images/2.jpg');"></div>
        <div class="slide" style="background-image: url('../../../assets/images/3.jpg');"></div>
    </div> -->
    <!-- <div *ngIf="backgroundMedia" class="slideshow">
        <div *ngFor="let media of backgroundMedia">
          
          <div class="slide active" [ngStyle]="{ 'background-image': 'url(' + getSafeAssetUrl(media) + ')' }"></div>          
        </div>
    </div> -->

    <div *ngIf="isBrowser && backgroundMedia" class="slideshow">
        <div *ngFor="let media of backgroundMedia">
            <div class="slide active"
                [style.background-image]="'url(' + getSafeAssetUrl(media) + ')'">
            </div>
        </div>
    </div>
    <!-- <div *ngIf="backgroundMedia" class="slideshow">
    <div *ngFor="let media of backgroundMedia">
        <div class="slide active"
            [style.background-image]="isBrowser ? ('url(' + getSafeAssetUrl(media) + ')') : null">
        </div>
    </div>
    </div>     -->

    <div class="content">
        <div class="form">
            <form #dynamicForm id="dynamicForm">
                <input id="SR_TOKEN" [(ngModel)]="formData['SR_TOKEN']" type="hidden" name="SR_TOKEN">
                <input id="xxTrustedFormCertUrl" [(ngModel)]="formData['xxTrustedFormCertUrl']" type="hidden" name="xxTrustedFormCertUrl">
                <input id="leadid_token" [(ngModel)]="formData['JornayaToken']" type="hidden" name="universal_leadid">
                <!-- <input ng-model="lead.SourceID" id="SourceID" name="SourceID" type="hidden" value="" /> -->
                <!-- <input ng-model="lead.DataSource" id="DataSource" name="DataSource" type="hidden" value="" />  -->
                <!-- Loader -->
                <div *ngIf="isLoading" class="loading">
                    <p>Cargando formulario...</p>
                </div>
                <!-- Pasos del formulario -->
                <div *ngIf="!isLoading" class="form-dynamic-container">
                    <div class="form-dynamic-header">
                        <div class="dynamic-progress-bar" [hidden]="hideProgress">
                            <div class="progress-bar" id="progress-bar"></div>
                            <div class="progress-dots" id="progress-dots"></div>
                        </div>
                        <span class="brand">  
                  <div class="brand-image-container">
                    <img class="image-links" *ngIf="brandingImage" [src]="getSafeImageUrl(brandingImage)"
                      [alt]="brandingImage.fields.title || 'Imagen decorativa'"  
                      (click)="openSecureWindow(brandingImage)">
                  </div>                                   
                    <span class="fa-solid" *ngIf="brandIcon" [ngClass]="brandIcon.fields.iconClass" aria-hidden="true"></span>
                        </span>
                    </div>
                    <div [@stepAnimation]="currentStep">
                        <app-form-step [steps]="steps" [step]="steps[currentStep]" [totalSteps]="this.steps.length" (dataChanged)="saveToLocalStorage()"></app-form-step>
                    </div>
                    <!-- Botones de navegación -->
                    <div class="navigation-buttons">
                        <button class="goback-button" [hidden]="!(currentStep > 0)" (click)="prevStep()">              
                            <span *ngIf="!formFlow?.fields?.backButtonText">Go Back</span>
                            <span *ngIf="formFlow?.fields?.backButtonText">{{formFlow?.fields?.backButtonText}}</span>
                        </button>
                        <button class="continue-button first-button" *ngIf="!(currentStep === (steps.length - 1))" (click)="nextStep()" [disabled]="!isStepValid()">
                            <!-- If para remover boton de los demas pasos -->
                            <!-- (currentStep >= 0 && currentStep <= 0 ) &&  -->
                            <span *ngIf="!formFlow?.fields?.nextButtonText">Next</span>
                            <span *ngIf="formFlow?.fields?.nextButtonText">{{formFlow?.fields?.nextButtonText}}</span>
                        </button>
                        <!-- <button class="continue-button" *ngIf="(currentStep >= 1) && !(currentStep === (steps.length - 1))" [hidden]="hideNextButton" (click)="nextStep()" [disabled]="!isStepValid()">
                            <span *ngIf="!formFlow?.fields?.nextButtonText">Next</span>
                            <span *ngIf="formFlow?.fields?.nextButtonText">{{formFlow?.fields?.nextButtonText}}</span>
                        </button> -->
                        <button class="" *ngIf="currentStep === steps.length - 1" (click)="submitForm()" [disabled]="!isStepValid()" class="submit-button">              
                            <span *ngIf="!formFlow?.fields?.submitButtonText">Send</span>
                            <span *ngIf="formFlow?.fields?.submitButtonText">{{formFlow?.fields?.submitButtonText}}</span>
                        </button> 
                    </div>

                    <div *ngIf="steps?.length === 0" class="error">
                    </div>
                </div>
                <div id="disclaimer1" class="disclaimer" style="height: 0px; overflow: hidden;">
                    <span class="conditions">
                <input type="hidden" id="leadid_tcpa_disclosure" autocomplete="off">
                  <div id="srDisclosure" ></div>
           </span>
                </div>
            </form>
            
            <!-- 2026-08-05: Jornaya is loaded from src/index.html instead of this Angular template.
            Data showed this improves iOS Safari token population for Contentful flows and avoids duplicate script paths.
            Keep this snippet here as reference only; do not enable it together with the index-level loader. -->
            <script id="LeadiDscript" type="text/javascript">
                (function() {
                    if (document.getElementById('LeadiDscript_campaign')) {
                        return;
                    }
                    var s = document.createElement('script');
                    s.id = 'LeadiDscript_campaign';
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = '//create.lidstatic.com/campaign/b859f212-ac87-5123-7ff4-6f51b2428493.js?snippet_version=2';
                    var LeadiDscript = document.getElementById('LeadiDscript');
                    LeadiDscript.parentNode.insertBefore(s, LeadiDscript);
                })();
            </script>
            <!-- <noscript><img src='//create.leadid.com/noscript.gif?lac=b4136bf0-2bce-fbc8-2e97-6d2d22f3cf46&lck=41d9e023-26ce-a91c-3630-a00890135123&snippet_version=2'/></noscript> -->           
            <!-- <noscript><img src='//create.leadid.com/noscript.gif?lac=b4136bf0-2bce-fbc8-2e97-6d2d22f3cf46&lck=41d9e023-26ce-a91c-3630-a00890135123&snippet_version=2'/></noscript> -->           
        </div>
    </div>

</div>
